import React from 'react';

// Colour-name aliases → available renders
const ALIAS = {
  gray: 'grey',
  navy: 'blue',
  maroon: 'red',
  gold: 'silver',
  yellow: 'orange',
  beige: 'silver',
  brown: 'grey',
  purple: 'blue',
};

const COLORS = ['white', 'silver', 'grey', 'black', 'red', 'blue', 'green', 'orange'];

const resolveColorKey = (colorName) => {
  if (!colorName) return 'silver';
  const key = String(colorName).trim().toLowerCase();
  const direct = COLORS.find((c) => key.includes(c));
  if (direct) return direct;
  const alias = Object.keys(ALIAS).find((a) => key.includes(a));
  return alias ? ALIAS[alias] : 'silver';
};

// Transparent, background-removed 3D car renders bundled in /public/cars.
export const sideCarSrc = (color) => `/cars/side_${resolveColorKey(color)}.png`;
export const topCarSrc = (color) => `/cars/top_${resolveColorKey(color)}.png`;

// Solid hex per resolved colour key, for UI accents (e.g. map pulse).
const COLOR_HEX = {
  white: '#e5e7eb',
  silver: '#cbd5e1',
  grey: '#9ca3af',
  black: '#374151',
  red: '#ef4444',
  blue: '#3b82f6',
  green: '#10b981',
  orange: '#f97316',
};
export const carColorHex = (color) => COLOR_HEX[resolveColorKey(color)] || COLOR_HEX.silver;

/**
 * Side-view 3D glossy vehicle render (transparent) tinted to the driver's colour.
 */
const Vehicle3D = ({ color, className = '', title }) => (
  <img
    src={sideCarSrc(color)}
    alt={title || `${color || 'Vehicle'} car`}
    className={className}
    loading="eager"
    style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
  />
);

export default Vehicle3D;
